module.exports = __webpack_public_path__ + "img/NanumSquareOTFR.1c1e7d5a.svg";